/**
 * Keys must match `resolveFontFamily` (Inter-*, Montserrat-*) — same as Android linked names.
 * Metro requires static `require()` per file.
 */
export const WEB_FONT_MAP = {
  'Inter-BlackItalic': require('@/assets/fonts/Inter-BlackItalic.ttf'),
  'Inter-ExtraLight': require('@/assets/fonts/Inter-ExtraLight.ttf'),
  'Inter-Black': require('@/assets/fonts/Inter-Black.ttf'),
  'Inter-ExtraLightItalic': require('@/assets/fonts/Inter-ExtraLightItalic.ttf'),
  'Inter-Light': require('@/assets/fonts/Inter-Light.ttf'),
  'Inter-Italic': require('@/assets/fonts/Inter-Italic.ttf'),
  'Inter-SemiBold': require('@/assets/fonts/Inter-SemiBold.ttf'),
  'Inter-Thin': require('@/assets/fonts/Inter-Thin.ttf'),
  'Inter-BoldItalic': require('@/assets/fonts/Inter-BoldItalic.ttf'),
  'Inter-ExtraBold': require('@/assets/fonts/Inter-ExtraBold.ttf'),
  'Inter-ThinItalic': require('@/assets/fonts/Inter-ThinItalic.ttf'),
  'Inter-Bold': require('@/assets/fonts/Inter-Bold.ttf'),
  'Inter-LightItalic': require('@/assets/fonts/Inter-LightItalic.ttf'),
  'Inter-Regular': require('@/assets/fonts/Inter-Regular.ttf'),
  'Inter-Medium': require('@/assets/fonts/Inter-Medium.ttf'),
  'Inter-SemiBoldItalic': require('@/assets/fonts/Inter-SemiBoldItalic.ttf'),
  'Inter-MediumItalic': require('@/assets/fonts/Inter-MediumItalic.ttf'),
  'Inter-ExtraBoldItalic': require('@/assets/fonts/Inter-ExtraBoldItalic.ttf'),
  'Montserrat-BlackItalic': require('@/assets/fonts/Montserrat-BlackItalic.ttf'),
  'Montserrat-ExtraBold': require('@/assets/fonts/Montserrat-ExtraBold.ttf'),
  'Montserrat-LightItalic': require('@/assets/fonts/Montserrat-LightItalic.ttf'),
  'Montserrat-BoldItalic': require('@/assets/fonts/Montserrat-BoldItalic.ttf'),
  'Montserrat-ExtraLightItalic': require('@/assets/fonts/Montserrat-ExtraLightItalic.ttf'),
  'Montserrat-Bold': require('@/assets/fonts/Montserrat-Bold.ttf'),
  'Montserrat-Thin': require('@/assets/fonts/Montserrat-Thin.ttf'),
  'Montserrat-SemiBold': require('@/assets/fonts/Montserrat-SemiBold.ttf'),
  'Montserrat-Medium': require('@/assets/fonts/Montserrat-Medium.ttf'),
  'Montserrat-Regular': require('@/assets/fonts/Montserrat-Regular.ttf'),
  'Montserrat-Italic': require('@/assets/fonts/Montserrat-Italic.ttf'),
  'Montserrat-Black': require('@/assets/fonts/Montserrat-Black.ttf'),
  'Montserrat-Light': require('@/assets/fonts/Montserrat-Light.ttf'),
  'Montserrat-ThinItalic': require('@/assets/fonts/Montserrat-ThinItalic.ttf'),
  'Montserrat-ExtraBoldItalic': require('@/assets/fonts/Montserrat-ExtraBoldItalic.ttf'),
  'Montserrat-MediumItalic': require('@/assets/fonts/Montserrat-MediumItalic.ttf'),
  'Montserrat-SemiBoldItalic': require('@/assets/fonts/Montserrat-SemiBoldItalic.ttf'),
  'Montserrat-ExtraLight': require('@/assets/fonts/Montserrat-ExtraLight.ttf'),
} as const;
